webpackJsonp([73080212364780],{

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get2 = __webpack_require__(10);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactGridSystem = __webpack_require__(27);
	
	var _gatsbyImage = __webpack_require__(7);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _heroModule = __webpack_require__(40);
	
	var _heroModule2 = _interopRequireDefault(_heroModule);
	
	var _blogPostModule = __webpack_require__(42);
	
	var _blogPostModule2 = _interopRequireDefault(_blogPostModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WeddingsIndex = function (_React$Component) {
	  _inherits(WeddingsIndex, _React$Component);
	
	  function WeddingsIndex() {
	    _classCallCheck(this, WeddingsIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WeddingsIndex.prototype.render = function render() {
	    var _get = (0, _get3.default)(this, 'props.data.allContentfulContentPage.edges'),
	        page = _get[0];
	
	    return _react2.default.createElement(
	      'div',
	      { style: { background: '#fff' } },
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Weddings | Signature Party Styling & Rentals' }),
	      _react2.default.createElement(
	        'div',
	        { className: _heroModule2.default.hero },
	        _react2.default.createElement(_gatsbyImage2.default, { className: _heroModule2.default.heroImage, alt: page.node.title, sizes: page.node.image.sizes })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _blogPostModule2.default.blogPageWrapper },
	        _react2.default.createElement(
	          'h1',
	          { className: 'section-headline' },
	          page.node.title
	        ),
	        _react2.default.createElement('div', { className: _blogPostModule2.default.sectionRTE, style: { marginBottom: '50px' },
	          dangerouslySetInnerHTML: {
	            __html: page.node.content.childMarkdownRemark.html
	          }
	        })
	      )
	    );
	  };
	
	  return WeddingsIndex;
	}(_react2.default.Component);
	
	exports.default = WeddingsIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-weddings-js-5294fdd25cbcee16bd03.js